<template>
  <div data-testid="task-notification-all">
    <!-- Step 1: Notification Type Selection Dialog -->
    <lb-dialog
      data-testid="task-notification-all__type-dialog"
      v-model="typeDialog"
      heading="Add Notification"
      width="800"
    >
      <template v-slot:body>
        <div class="d-flex flex-column align-center gap-2">
          <h3 data-testid="task-notification-all__type-dialog-title">
            Select your Notification type
          </h3>
          <h5
            class="font-weight-medium choose-category"
            data-testid="task-notification-all__type-dialog-subtitle"
          >
            Choose the category to configure unique parameters
          </h5>
        </div>
        <lb-dropdown
          data-testid="task-notification-all__notification-type-dropdown"
          class="mt-3"
          label="Notification type"
          v-model="notification.type"
          :items="notificationTypes"
          itemtext="name"
          itemvalue="value"
        />
      </template>
      <template v-slot:actions>
        <v-spacer data-testid="task-notification-all__type-dialog-spacer"></v-spacer>
        <v-btn
          data-testid="task-notification-all__next-step-btn"
          color="primary"
          :disabled="!notification.type || notification.type.length === 0"
          @click="handleNextStep"
        >
          <span>Next step</span>
        </v-btn>
      </template>
    </lb-dialog>

    <!-- Step 2: Notification Configuration Dialog -->
    <lb-dialog
      data-testid="task-notification-all__config-dialog"
      v-model="configDialog"
      heading="Escalation Mail Setup"
      width="800"
      transition="right"
    >
      <template v-slot:body>
        <!-- Task List Escalation Notification Form -->
        <div
          class="d-flex flex-column gap-6"
          v-if="selectedNotificationType === NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION"
          data-testid="task-notification-all__task-list-form"
        >
          <div>
            <h3 data-testid="task-notification-all__task-list-heading">
              {{ selectedNotificationTypeName }}:
            </h3>
          </div>
          <v-row dense>
            <!-- <v-col cols="6" data-testid="task-notification-all__task-list-start-date-col">
              <lb-date
                data-testid="task-notification-all__task-list-start-date"
                label="Start Date"
                v-model="taskListNotification.start"
                :hidedetails="!errors.taskList.start"
                :error="errors.taskList.start"
              />
              <div class="d-flex align-center">
                <v-icon class="pa-2">mdi-information-outline</v-icon>
                <div class="font-size-sm" data-testid="task-notification-all__task-list-cycle-info">
                  Cycle Created for {{ cycleDuration }} days
                </div>
              </div>
            </v-col> -->
            <!-- <v-col cols="6" data-testid="task-notification-all__task-list-end-date-col">
              <lb-date
                data-testid="task-notification-all__task-list-end-date"
                label="End Date"
                v-model="taskListNotification.end"
                :error="errors.taskList.end"
              />
            </v-col> -->
            <v-col cols="12" data-testid="task-notification-all__dashboard-email-col">
                 <lb-string 
                data-testid="task-notification-all__dashboard-endDays-dropdown"
                label="End of Days*"
                v-model="taskListNotification.endDays"
                :error="errors.taskList.endDays"
                :hidedetails="!errors.taskList.endDays"
              />
                 <div class="d-flex align-center">
                <v-icon class="pa-2">mdi-information-outline</v-icon>
                <div class="font-size-sm" data-testid="task-notification-all__dashboard-cycle-info">
                 The notification ends 15 days before the cycle end date.
                </div>
              </div>
            </v-col>
            <v-col cols="12" data-testid="task-notification-all__task-list-category-col">
              <lb-dropdown
                data-testid="task-notification-all__task-list-category-dropdown"
                label="Category*"
                multiple
                v-model="taskListNotification.category"
                :items="categories"
                itemtext="name"
                itemvalue="id"
                :error="errors.taskList.category"
              />
            </v-col>
            <v-col cols="12" data-testid="task-notification-all__task-list-email-col">
                <lb-tagsInput data-testid="financialclose-project-users__email-addresses" tagcolor="purpleborder" :multiple="true" v-model="taskListNotification.emails" :multiplechips="true" label="Email Address*" outline :error="errors.taskList.emails ? [errors.taskList.emails] : invalidEmails" />
            </v-col>
            <v-col cols="12" data-testid="task-notification-all__task-list-subject-col">
              <lb-string 
                data-testid="task-notification-all__task-list-subject-dropdown"
                label="Email Subject*"
                v-model="taskListNotification.subject"
                :error="errors.taskList.subject"
              />
            </v-col>
            <v-col cols="12" data-testid="task-notification-all__task-list-body-col">
              <lb-textarea
                data-testid="task-notification-all__task-list-body-textarea"
                label="Email Body*"
                v-model="taskListNotification.body"
                :error="errors.taskList.body"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__task-list-location-col">
              <lb-dropdown
                data-testid="task-notification-all__task-list-location-dropdown"
                label="Location*"
                multiple
                v-model="taskListNotification.location"
                :hidedetails="!errors.taskList.location"
                :items="locations"
                itemtext="name"
                itemvalue="value"
                :error="errors.taskList.location"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__task-list-hour-col">
              <lb-dropdown
                data-testid="task-notification-all__task-list-hour-dropdown"
                label="Hour*"
                :items="timeList"
                v-model="taskListNotification.hour"
                @change="generateTaskListTimeMultiples"
                :hidedetails="!errors.taskList.hour"
                itemtext="name"
                itemvalue="value"
                :error="errors.taskList.hour"
              />
            </v-col>
            <v-col
              cols="12"
              class="mb-2"
              v-if="timeMultiplesTaskList.length"
              data-testid="task-notification-all__task-list-triggers-col"
            >
              <p class="ma-0">Sample Days:</p>
              <ul class="d-flex flex-wrap" style="list-style: none; padding-left: 0;">
                <li
                  data-testid="task-notification-all__task-list-trigger-item"
                  class="me-4"
                  v-for="(time, index) in timeMultiplesTaskList"
                  :key="index"
                >
                  {{ time }}
                </li>
              </ul>
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__task-list-sla-col">
              <lb-dropdown
                data-testid="task-notification-all__task-list-sla-dropdown"
                label="SLA*"
                v-model="taskListNotification.sla"
                :items="slaList"
                itemtext="name"
                itemvalue="id"
                :error="errors.taskList.sla"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__task-list-priority-col">
              <lb-dropdown
                data-testid="task-notification-all__task-list-priority-dropdown"
                label="Priority*"
                v-model="taskListNotification.priority"
                :items="priorityList"
                itemtext="name"
                itemvalue="id"
                :error="errors.taskList.priority"
                disabled
              />
            </v-col>
          </v-row>
          <div class="error--text" data-testid="task-notification-all__task-list-notice">
            {{ SCHEDULE_CHANGE_NOTICE }}
          </div>
        </div>

        <!-- Dashboard Notification Form -->
        <div
          class="d-flex flex-column gap-6"
          v-if="selectedNotificationType === NOTIFICATION_TYPE_KEYS.DASHBOARD"
          data-testid="task-notification-all__dashboard-form"
        >
          <div>
            <h3 data-testid="task-notification-all__dashboard-heading">
              {{ selectedNotificationTypeName }}:
            </h3>
          </div>
          <v-row dense>
            <!-- <v-col cols="6" data-testid="task-notification-all__dashboard-start-date-col">
              <lb-date
                data-testid="task-notification-all__dashboard-start-date"
                label="Start Date"
                v-model="dashboardNotification.startDate"
                :hidedetails="!errors.dashboard.startDate"
                :error="errors.dashboard.startDate"
              />
              <div class="d-flex align-center">
                <v-icon class="pa-2">mdi-information-outline</v-icon>
                <div class="font-size-sm" data-testid="task-notification-all__dashboard-cycle-info">
                  Cycle Created for {{ cycleDuration }} days
                </div>
              </div>
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__dashboard-end-date-col">
              <lb-date
                data-testid="task-notification-all__dashboard-end-date"
                label="End Date"
                v-model="dashboardNotification.endDate"
                :error="errors.dashboard.endDate"
              />
            </v-col> -->
             <v-col cols="12" data-testid="task-notification-all__dashboard-email-col">
                 <lb-string 
                data-testid="task-notification-all__dashboard-endDays-dropdown"
                label="End of Days*"
                v-model="dashboardNotification.endDays"
                :error="errors.dashboard.endDays"
                :hidedetails="!errors.dashboard.endDays"
              />
                 <div class="d-flex align-center">
                <v-icon class="pa-2">mdi-information-outline</v-icon>
                <div class="font-size-sm" data-testid="task-notification-all__dashboard-cycle-info">
                 The notification ends 15 days before the cycle end date.
                </div>
              </div>
            </v-col>
            <v-col cols="12" data-testid="task-notification-all__dashboard-email-col">
                <lb-tagsInput data-testid="financialclose-project-users__email-addresses" tagcolor="purpleborder" :multiple="true" v-model="dashboardNotification.emails" :multiplechips="true" label="Email Address*" outline :error="errors.dashboard.emails ? [errors.dashboard.emails] : dashboardinvalidEmails" />
            </v-col>
            <v-col cols="12" data-testid="task-notification-all__dashboard-subject-col">
              <lb-string 
                data-testid="task-notification-all__dashboard-subject-dropdown"
                label="Email Subject"
                v-model="dashboardNotification.subject"
                :error="errors.dashboard.subject"
              />
            </v-col>
            <v-col cols="12" data-testid="task-notification-all__dashboard-body-col">
              <lb-textarea
                data-testid="task-notification-all__dashboard-body-textarea"
                label="Email Body"
                v-model="dashboardNotification.body"
                :error="errors.dashboard.body"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__dashboard-location-col">
              <lb-dropdown
                data-testid="task-notification-all__dashboard-location-dropdown"
                label="Location"
                multiple
                v-model="dashboardNotification.location"
                :items="locations"
                itemtext="name"
                itemvalue="value"
                :error="errors.dashboard.location"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__dashboard-hour-col">
              <lb-dropdown
                data-testid="task-notification-all__dashboard-hour-dropdown"
                label="Hour*"
                :items="timeList"
                v-model="dashboardNotification.hour"
                @change="generateDashboardTimeMultiples"
                itemtext="name"
                itemvalue="value"
                :error="errors.dashboard.hour"
              />
            </v-col>
            <v-col
              cols="12"
              class="pt-0"
              v-if="timeMultiplesDashboard.length"
              data-testid="task-notification-all__dashboard-triggers-col"
            >
              <p class="ma-0">Sample Days:</p>
              <ul class="d-flex flex-wrap" style="list-style: none; padding-left: 0;">
                <li
                  data-testid="task-notification-all__dashboard-trigger-item"
                  class="me-4"
                  v-for="(time, index) in timeMultiplesDashboard"
                  :key="index"
                >
                  {{ time }}
                </li>
              </ul>
            </v-col>
          </v-row>
          <div class="error--text" data-testid="task-notification-all__dashboard-notice">
            {{ SCHEDULE_CHANGE_NOTICE }}
          </div>
        </div>

        <!-- Due Today Notification Form -->
        <div
          class="d-flex flex-column gap-6"
          v-if="selectedNotificationType === NOTIFICATION_TYPE_KEYS.DUE_TODAY"
          data-testid="task-notification-all__due-today-form"
        >
          <div>
            <h3 data-testid="task-notification-all__due-today-heading">
              {{ selectedNotificationTypeName }}:
            </h3>
          </div>
          <v-row dense>
            <v-col cols="6" data-testid="task-notification-all__due-today-scheduler-col">
              <lb-dropdown
                data-testid="task-notification-all__due-today-scheduler-dropdown"
                label="Scheduler*"
                v-model="dueTodayNotification.scheduler"
                :items="timeList"
                itemtext="name"
                itemvalue="value"
                :error="errors.dueToday.scheduler"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__due-today-status-col">
               <div class="d-flex ma-0">
                <span class="mr-5 ma-0">Status</span>
                 <v-switch
                class="ma-0"
                v-model="dueTodayNotification.status"
                data-testid="task-notification-all__due-today-status-switch"
                inset
              ></v-switch>
              </div>
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__due-today-location-col">
              <lb-dropdown
                data-testid="task-notification-all__due-today-location-dropdown"
                label="Location"
                multiple
                v-model="dueTodayNotification.location"
                :items="locations"
                itemtext="name"
                itemvalue="value"
                :error="errors.dueToday.location"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__due-today-role-col">
              <lb-dropdown
                data-testid="task-notification-all__due-today-role-dropdown"
                label="Role*"
                v-model="dueTodayNotification.role"
                :items="roles"
                itemtext="name"
                itemvalue="value"
                :error="errors.dueToday.role"
              />
            </v-col>
          </v-row>
          <div class="error--text" data-testid="task-notification-all__due-today-notice">
            {{ SCHEDULE_CHANGE_NOTICE }}
          </div>
        </div>

        <!-- Overdue Task Notification Form -->
        <div
          class="d-flex flex-column gap-6"
          v-if="selectedNotificationType === NOTIFICATION_TYPE_KEYS.OVERDUE_TASK"
          data-testid="task-notification-all__overdue-form"
        >
          <div>
            <h3 data-testid="task-notification-all__overdue-heading">
              {{ selectedNotificationTypeName }}:
            </h3>
          </div>
          <v-row dense>
            <v-col cols="6" data-testid="task-notification-all__overdue-scheduler-col">
              <lb-dropdown
                data-testid="task-notification-all__overdue-scheduler-dropdown"
                label="Scheduler*"
                v-model="overdueTaskNotification.scheduler"
                :items="timeList"
                itemtext="name"
                itemvalue="value"
                :error="errors.overdue.scheduler"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__overdue-status-col">
              <div class="d-flex ma-0">
                <span class="mr-5 ma-0">Status</span>
                 <v-switch
                class="ma-0"
                v-model="overdueTaskNotification.status"
                data-testid="task-notification-all__overdue-status-switch"
                inset
              ></v-switch>
              </div>
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__overdue-location-col">
              <lb-dropdown
                data-testid="task-notification-all__overdue-location-dropdown"
                label="Location"
                multiple
                v-model="overdueTaskNotification.location"
                :items="locations"
                itemtext="name"
                itemvalue="value"
                :error="errors.overdue.location"
              />
            </v-col>
            <v-col cols="6" data-testid="task-notification-all__overdue-role-col">
              <lb-dropdown
                data-testid="task-notification-all__overdue-role-dropdown"
                label="Role*"
                v-model="overdueTaskNotification.role"
                :items="roles"
                itemtext="name"
                itemvalue="value"
                :error="errors.overdue.role"
              />
            </v-col>
          </v-row>
          <div class="error--text" data-testid="task-notification-all__overdue-notice">
            {{ SCHEDULE_CHANGE_NOTICE }}
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer data-testid="task-notification-all__config-dialog-spacer"></v-spacer>
        <v-btn
          data-testid="task-notification-all__finish-btn"
          color="primary"
          @click="handleSubmit"
        >
          <span>Finish</span>
        </v-btn>
      </template>
    </lb-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { 
  EMAIL_NOTIFICATION, 
  CRON, 
  NOTIFICATION_DEFAULTS,
  NOTIFICATION_TYPE_KEYS,
  NOTIFICATION_TYPES,
  SCHEDULE_CHANGE_NOTICE
} from "../../utils/constants";
import { validateRequiredFields } from "../../utils/validationUtils";

export default {
  name: "TaskNotificationAll",

  props: {
    /** Controls visibility of type selection dialog */
    showTypeDialog: {
      type: Boolean,
      default: false,
    },
    /** Available locations for dropdown */
    locations: {
      type: Array,
      default: () => [],
    },
    /** Available categories for dropdown */
    categories: {
      type: Array,
      default: () => [],
    },
    /** Available roles for dropdown */
    roles: {
      type: Array,
      default: () => EMAIL_NOTIFICATION.roles ?? [],
    },
    /** Available time list for scheduler */
    timeList: {
      type: Array,
      default: () => EMAIL_NOTIFICATION.timeList ?? [],
    },
    /** Edit mode data - when editing existing notification */
    editData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      // Dialog visibility states
      typeDialog: false,
      configDialog: false,

      // Selected notification type
      selectedNotificationType: null,

      // Notification type selection
      notification: {
        type: this.editData?.feature || null,
      },

      // Available notification types
      notificationTypes: NOTIFICATION_TYPES,

      // Form data for Task List Escalation notification
      taskListNotification: { ...JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.TASK_LIST)), priority: "High" },

      // Form data for Dashboard notification
      dashboardNotification: JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.DASHBOARD)),

      // Form data for Due Today notification
      dueTodayNotification: JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.DUE_TODAY)),

      // Form data for Overdue Task notification
      overdueTaskNotification: JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.OVERDUE_TASK)),

      // Time multiples for displaying next 5 triggers
      timeMultiplesDashboard: [],
      timeMultiplesTaskList: [],

      // Dropdown options
      slaList: [
        { name: "SLA1 (48 Hrs)", id: 1 },
        { name: "SLA2 (72 Hrs)", id: 2 },
      ],
      priorityList: [
        { name: "High", id: "High" },
        { name: "Medium", id: "Medium" },
        { name: "Low", id: "Low" },
      ],

      // Constants exposed to template
      NOTIFICATION_TYPE_KEYS,
      SCHEDULE_CHANGE_NOTICE,

      // Store edit notification ID locally
      editNotificationId: null,

      // Validation errors
      errors: {
        taskList: {},
        dashboard: {},
        dueToday: {},
        overdue: {},
      },
    };
  },

  computed: {
    invalidEmails() {
      return this.getInvalidEmailsList(this.taskListNotification.emails);
    },
    dashboardinvalidEmails() {
      return this.getInvalidEmailsList(this.dashboardNotification.emails);
    },
    /**
     * Returns the display name for the selected notification type
     * @returns {string} Display name of selected notification type
     */
    selectedNotificationTypeName() {
      const selected = this.notificationTypes.find(
        (type) => type.value === this.selectedNotificationType
      );
      return selected?.name || this.selectedNotificationType;
    },

    /**
     * Calculates cycle duration based on start and end dates
     * @returns {number} Duration in days
     */
    // cycleDuration() {
    //   let start, end;

    //   if (
    //     this.selectedNotificationType === NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION
    //   ) {
    //     start = this.taskListNotification.start;
    //     end = this.taskListNotification.end;
    //   } else if (
    //     this.selectedNotificationType === NOTIFICATION_TYPE_KEYS.DASHBOARD
    //   ) {
    //     start = this.dashboardNotification.startDate;
    //     end = this.dashboardNotification.endDate;
    //   }

    //   if (start && end) {
    //     const startDate = moment(start);
    //     const endDate = moment(end);
    //     const diff = endDate.diff(startDate, "days");
    //     return diff >= 0 ? diff : 0;
    //   }
    //   return DEFAULT_CYCLE_DURATION;
    // },
  },

  watch: {
    /**
     * Syncs external showTypeDialog prop with internal typeDialog state
     */
    showTypeDialog: {
      immediate: true,
      handler(newVal) {
        this.typeDialog = newVal;
      },
    },

    /**
     * Emits close event when typeDialog changes
     */
    typeDialog(newVal) {
      if (!newVal) {
        this.$emit("close");
      }
    },

    /**
     * Resets forms and emits close event when configDialog changes
     */
    configDialog(newVal) {
      if (!newVal) {
        this.resetAllForms();
        this.$emit("close");
      }
    },

    /**
     * Auto-sets end date when task list start date changes
     */
    // "taskListNotification.start": function (newVal) {
    //   if (newVal) {
    //     const startDate = moment(newVal);
    //     if (startDate.isValid()) {
    //       this.taskListNotification.end = startDate
    //         .clone()
    //         .add(DEFAULT_CYCLE_DURATION, "days")
    //         .format("YYYY-MM-DD");
    //     }
    //   }
    // },

    /**
     * Auto-sets end date when dashboard start date changes
     */
    // "dashboardNotification.startDate": function (newVal) {
    //   if (newVal) {
    //     const startDate = moment(newVal);
    //     if (startDate.isValid()) {
    //       this.dashboardNotification.endDate = startDate
    //         .clone()
    //         .add(DEFAULT_CYCLE_DURATION, "days")
    //         .format("YYYY-MM-DD");
    //     }
    //   }
    // },

    /**
     * Populates form when editData is provided
     */
    editData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.populateEditData(newVal);
        }
      },
    },
  },

  beforeDestroy() {
    // Reset all data to prevent stale state on re-entry
    this.resetAllForms();
  },

  methods: {
    ...mapActions("taskDueNotifications", ["fetchAllCreatedNotifications", "saveNotification"]),

    /**
     * Handles next step button click - moves from type selection to config dialog
     */
    handleNextStep() {
      this.selectedNotificationType = this.notification.type;
      this.typeDialog = false;
      this.configDialog = true;
    },

    /**
     * Handles form submission based on selected notification type
     */
    async handleSubmit() {
      const typeHandlers = {
        [NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION]: this.submitTaskListNotification,
        [NOTIFICATION_TYPE_KEYS.DASHBOARD]: this.submitDashboardNotification,
        [NOTIFICATION_TYPE_KEYS.DUE_TODAY]: this.submitDueTodayNotification,
        [NOTIFICATION_TYPE_KEYS.OVERDUE_TASK]: this.submitOverdueNotification,
      };

      const handler = typeHandlers[this.selectedNotificationType];
      if (handler) {
        await handler();
      } else {
        console.error("[TaskNotificationAll]: No handler found for type -", this.selectedNotificationType);
      }
    },

    /**
     * Validates Task List Escalation notification form
     */
    validateTaskList() {
      const requiredFields = [
        // { key: "start", label: "Start Date" },
        // { key: "end", label: "End Date" },
        { key: "endDays", label: "End of Days" },
        { key: "category", label: "Category" },
        { key: "emails", label: "Email Address" },
        { key: "subject", label: "Email Subject" },
        { key: "body", label: "Email Body" },
        { key: "location", label: "Location" },
        { key: "hour", label: "Hour" },
        { key: "sla", label: "SLA" },
        { key: "priority", label: "Priority" },
      ];

      this.errors.taskList = validateRequiredFields(this.taskListNotification, requiredFields);
      return Object.keys(this.errors.taskList).length === 0;
    },

    /**
     * Submits Task List Escalation notification
     */
    async submitTaskListNotification() {
      if (!this.validateTaskList()) return;
      try {
        const payload = this.buildTaskListPayload();
        await this.submitNotification(
          NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION,
          payload
        );
        this.handleSubmitSuccess();
      } catch (error) {
        this.handleSubmitError(error);
      }
    },

    /**
     * Validates Dashboard notification form
     */
    validateDashboard() {
      const requiredFields = [
          // { key: "startDate", label: "Start Date" },
          // { key: "endDate", label: "End Date" },
        { key: "endDays", label: "End of Days" },
        { key: "emails", label: "Email Address" },
        { key: "subject", label: "Email Subject" },
        { key: "body", label: "Email Body" },
        { key: "location", label: "Location" },
        { key: "hour", label: "Hour" },
      ];

      this.errors.dashboard = validateRequiredFields(this.dashboardNotification, requiredFields);
      return Object.keys(this.errors.dashboard).length === 0;
    },

    /**
     * Submits Dashboard notification
     */
    async submitDashboardNotification() {
      if (!this.validateDashboard()) return;
      try {
        const payload = this.buildDashboardPayload();
        await this.submitNotification(
          NOTIFICATION_TYPE_KEYS.DASHBOARD,
          payload
        );
        this.handleSubmitSuccess();
      } catch (error) {
        this.handleSubmitError(error);
      }
    },

    /**
     * Validates Due Today notification form
     */
    validateDueToday() {
      const requiredFields = [
        { key: "scheduler", label: "Scheduler" },
        { key: "location", label: "Location" },
        { key: "role", label: "Role" },
      ];

      this.errors.dueToday = validateRequiredFields(this.dueTodayNotification, requiredFields);
      return Object.keys(this.errors.dueToday).length === 0;
    },

    /**
     * Submits Due Today notification
     */
    async submitDueTodayNotification() {
      if (!this.validateDueToday()) return;
      try {
        const payload = this.buildDueTodayPayload();
        await this.submitNotification(
          NOTIFICATION_TYPE_KEYS.DUE_TODAY,
          payload
        );
        this.handleSubmitSuccess();
      } catch (error) {
        this.handleSubmitError(error);
      }
    },

    /**
     * Validates Overdue Task notification form
     */
    validateOverdue() {
      const requiredFields = [
        { key: "scheduler", label: "Scheduler" },
        { key: "location", label: "Location" },
        { key: "role", label: "Role" },
      ];

      this.errors.overdue = validateRequiredFields(this.overdueTaskNotification, requiredFields);
      return Object.keys(this.errors.overdue).length === 0;
    },

    /**
     * Submits Overdue Task notification
     */
    async submitOverdueNotification() {
      if (!this.validateOverdue()) return;
      try {
        const payload = this.buildOverduePayload();
        await this.submitNotification(
          NOTIFICATION_TYPE_KEYS.OVERDUE_TASK,
          payload
        );
        this.handleSubmitSuccess();
      } catch (error) {
        this.handleSubmitError(error);
      }
    },

    /**
     * Makes API call to submit notification
     * @param {string} type - Notification type
     * @param {Object} payload - Request payload
     */
    async submitNotification(type, payload) {
      return await this.saveNotification({ type, payload });
    },

    /**
     * Handles successful submission
     */
    handleSubmitSuccess() {
      // Success message is already handled in the store action
      // this.$store.commit("sbSuccess", EMAIL_NOTIFICATION.MESSAGES.SUCCESS_CREATE);
      this.closeDialogs();
      this.$emit("submit-success");
    },

    /**
     * Handles submission error
     * @param {Error} error - Error object
     */
    handleSubmitError(error) {
      console.error("[TaskNotificationAll]: Submit error -", error);
      // Error message is already handled in the store action
      // this.$store.commit(
      //   "sbError",
      //   error?.message || "Failed to save notification"
      // );
    },

    /**
     * Builds payload for Task List notification
     * @returns {Object} Request payload
     */
    buildTaskListPayload() {
      return {
         featureDetails: {
        emails: this.taskListNotification.emails,
        subject: this.taskListNotification.subject,
        mailBody: this.taskListNotification.body,
        location: this.taskListNotification.location,
        flag: true,
        meta:{
            location_key: this.taskListNotification.location,
            toUsers: this.taskListNotification.emails,
            // start: this.taskListNotification.start,
            // end: this.taskListNotification.end,
            endDays:this.taskListNotification.endDays,
            category: this.taskListNotification.category,
            sla: this.taskListNotification.sla,
            priority: this.taskListNotification.priority,
        },
        schedulerTiming: CRON.hourToCronFormat(this.taskListNotification.hour),
        feature: NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION,
        _id: this.editNotificationId,
      }
    }
    },

    /**
     * Builds payload for Dashboard notification
     * @returns {Object} Request payload
     */
    buildDashboardPayload() {
      return {
        featureDetails: {
        emailAddress: this.dashboardNotification.emailAddress,
        subject: this.dashboardNotification.subject,
        mailBody: this.dashboardNotification.body,
        location: this.dashboardNotification.location,
        flag: true,
        meta:{
            location_key: this.dashboardNotification.location,
            toUsers: this.dashboardNotification.emails,
            // start: this.dashboardNotification.startDate,
            // end: this.dashboardNotification.endDate,
            endDays:this.dashboardNotification.endDays,
        },
        schedulerTiming: CRON.hourToCronFormat(this.dashboardNotification.hour),
        feature: NOTIFICATION_TYPE_KEYS.DASHBOARD,
         _id: this.editNotificationId,
      }
    }
    },

    /**
     * Builds payload for Due Today notification
     * @returns {Object} Request payload
     */
    buildDueTodayPayload() {
      return {
        featureDetails: {
        schedulerTiming: CRON.hourToCronFormat(this.dueTodayNotification.scheduler),
        flag: this.dueTodayNotification.status,
        location: this.dueTodayNotification.location,
        roles: this.dueTodayNotification.role,
        feature: NOTIFICATION_TYPE_KEYS.DUE_TODAY,
         meta:{
            locations: this.dueTodayNotification.location,
            roles: [this.dueTodayNotification.role],
        },
         _id: this.editNotificationId,
        }   
      };
    },

    /**
     * Builds payload for Overdue notification
     * @returns {Object} Request payload
     */
    buildOverduePayload() {
      return {
        featureDetails: {
        schedulerTiming: CRON.hourToCronFormat(this.overdueTaskNotification.scheduler),
        flag: this.overdueTaskNotification.status,
        location: this.overdueTaskNotification.location,
        roles: this.overdueTaskNotification.role,
        feature: NOTIFICATION_TYPE_KEYS.OVERDUE_TASK,
         meta:{
            locations: this.overdueTaskNotification.location,
            roles: [this.overdueTaskNotification.role],
        },
         _id: this.editNotificationId,
        }
      };
    },

    /**
     * Calculates next 5 time triggers for a given hour
     * @param {string} selectedHour - Selected hour value
     * @returns {Array} Array of formatted time strings
     */
    calculateTimeMultiples(selectedHour) {
      const baseHour = parseInt(selectedHour);
      if (isNaN(baseHour)) {
        return [];
      }

      const getGMTOffset = (date) => {
        const offset = -date.getTimezoneOffset();
        const sign = offset >= 0 ? "+" : "-";
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
        const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
        return `GMT${sign}${hours}:${minutes}`;
      };

      const baseUTC = new Date();
      baseUTC.setUTCHours(0, 0, 0, 0);

      return Array.from({ length: 5 }, (_, i) => {
        const timeUTC = new Date(baseUTC.getTime());
        timeUTC.setUTCDate(baseUTC.getUTCDate() + i);
        timeUTC.setUTCHours(baseHour, 0, 0, 0);

        const localDate = new Date(timeUTC);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, "0");
        const day = String(localDate.getDate()).padStart(2, "0");
        const hours = String(localDate.getHours()).padStart(2, "0");
        const minutes = String(localDate.getMinutes()).padStart(2, "0");
        const seconds = String(localDate.getSeconds()).padStart(2, "0");
        const timezone = getGMTOffset(localDate);

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${timezone}`;
      });
    },

    /**
     * Generates time multiples for Task List notification
     * @param {string} selectedHour - Selected hour value
     */
    generateTaskListTimeMultiples(selectedHour) {
      this.timeMultiplesTaskList = this.calculateTimeMultiples(selectedHour);
    },

    /**
     * Generates time multiples for Dashboard notification
     * @param {string} selectedHour - Selected hour value
     */
    generateDashboardTimeMultiples(selectedHour) {
      this.timeMultiplesDashboard = this.calculateTimeMultiples(selectedHour);
    },

    /**
     * Populates form data for edit mode
     * @param {Object} data - Edit data from parent
     */
    populateEditData(data) {
      if (!data || !data.type) return;
      // Store the notification ID for update operations
      this.editNotificationId = data._id || null;

      this.selectedNotificationType = data.type || data.feature;
      this.notification.type = '';

      // Helper to parse status/flag as boolean
      const parseStatusAsBoolean = (status, flag) => {
        if (typeof flag === 'boolean') return flag;
        if (typeof status === 'boolean') return status;
        if (status === 'enabled' || status === true) return true;
        return false;
      };

      // Helper to ensure array format for locations/roles
      const ensureArray = (value) => {
        if (Array.isArray(value)) return value;
        if (value) return [value];
        return [];
      };

      // Helper to format date to YYYY-MM-DD format for lb-date component
      // const formatDateForInput = (dateValue) => {
      //   if (!dateValue) return "";
      //   // If already in YYYY-MM-DD format, return as is
      //   if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
      //     return dateValue;
      //   }
      //   // Try to parse and format the date
      //   const parsed = moment(dateValue);
      //   if (parsed.isValid()) {
      //     return parsed.format("YYYY-MM-DD");
      //   }
      //   return "";
      // };

      // Helper to populate common fields for Due Today and Overdue Task
      const populateCommonFields = (targetObject) => ({
        ...targetObject,
        scheduler: data.scheduler || data.schedulerTiming || null,
        status: parseStatusAsBoolean(data.status, data.flag),
        location: ensureArray(data.location || data.locations),
        role: (data.role && data.role[0]) || (data.roles && data.roles[0]) || null,
      });

      // Populate respective form based on type
      const populateHandlers = {
        [NOTIFICATION_TYPE_KEYS.TASK_LIST_ESCALATION]: () => {
          this.taskListNotification = { 
            ...this.taskListNotification, 
            // start: startValue,
            // end: endValue,
            endDays: data.endDays || data.meta?.endDays || "",
            hour: data.hour || data.schedulerTiming || "",
            category: ensureArray(data.category || data.meta?.category),
            emails: data.emails || data.meta?.toUsers || null,
            subject: data.subject || null,
            body: data.body || data.mailBody || "",
            location: ensureArray(data.location || data.locations || data.meta?.location_key),
            sla: data.sla || null,
            priority: "High",
          };
          // Generate time multiples if hour is set
          if (this.taskListNotification.hour) {
            this.generateTaskListTimeMultiples(this.taskListNotification.hour);
          }
        },
        [NOTIFICATION_TYPE_KEYS.DASHBOARD]: () => {
          this.dashboardNotification = { 
            ...this.dashboardNotification, 
            // startDate: startDateValue,
            // endDate: endDateValue,
            endDays: data.endDays || data.meta?.endDays || "",
            hour: data.hour || data.schedulerTiming || "",
            emails: data.emails || data.meta?.toUsers || null,
            subject: data.subject || null,
            body: data.body || data.mailBody || "",
            location: ensureArray(data.location || data.locations || data.meta?.location_key),
          };
          // Generate time multiples if hour is set
          if (this.dashboardNotification.hour) {
            this.generateDashboardTimeMultiples(this.dashboardNotification.hour);
          }
        },
        [NOTIFICATION_TYPE_KEYS.DUE_TODAY]: () => {
          this.dueTodayNotification = populateCommonFields(this.dueTodayNotification);
        },
        [NOTIFICATION_TYPE_KEYS.OVERDUE_TASK]: () => {
          this.overdueTaskNotification = populateCommonFields(this.overdueTaskNotification);
        },
      };

      const handler = populateHandlers[this.selectedNotificationType];
      if (handler) {
        handler();
        this.configDialog = true;
        this.typeDialog = false;
      }
    },

    /**
     * Closes all dialogs and emits close event
     */
    closeDialogs() {
      this.typeDialog = false;
      this.configDialog = false;
      this.$emit("close");
    },

    /**
     * Resets all form data to default values
     */
    resetAllForms() {
      this.notification = { type: null };
      this.selectedNotificationType = null;

      this.taskListNotification = { ...JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.TASK_LIST)), priority: "High" };
      this.dashboardNotification = JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.DASHBOARD));
      this.dueTodayNotification = JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.DUE_TODAY));
      this.overdueTaskNotification = JSON.parse(JSON.stringify(NOTIFICATION_DEFAULTS.OVERDUE_TASK));

      this.timeMultiplesDashboard = [];
      this.timeMultiplesTaskList = [];

      // Reset edit notification ID
      this.editNotificationId = null;

      // Reset errors
      this.errors = {
        taskList: {},
        dashboard: {},
        dueToday: {},
        overdue: {},
      };
    },

    /**
     * Opens the type selection dialog
     */
    openDialog() {
      this.resetAllForms();
      this.typeDialog = true;
    },

    /**
     * Validates a list of emails and returns error messages for invalid ones
     * @param {Array} emails - List of emails to validate
     * @returns {Array} List of error messages
     */
    getInvalidEmailsList(emails) {
      if (emails && Array.isArray(emails)) {
        return emails
          .filter((email) => !this.isValidEmail(email))
          .map((email) => `${email} is not a valid email.`);
      }
      return [];
    },

    /**
     * Validates email format
     * @param {string} email - Email address to validate
     * @returns {boolean} True if email is valid
     */
    isValidEmail(email) {
      if (!email) return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
  },
};
</script>

<style scoped>
.choose-category {
  color: var(--color-breadcrumb-text);
}
</style>
